var exports = {
  "gS": "copilotMessage__F9B8qa",
  "dP": "copilotMessageContent__eWV02Q",
};

module.exports = exports;
